import { render, staticRenderFns } from "./estilo-vida.vue?vue&type=template&id=c7b3f20e&scoped=true&"
import script from "./estilo-vida.vue?vue&type=script&lang=js&"
export * from "./estilo-vida.vue?vue&type=script&lang=js&"
import style0 from "./estilo-vida.vue?vue&type=style&index=0&id=c7b3f20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b3f20e",
  null
  
)

export default component.exports